export default __webpack_public_path__ + "static/media/PersonalWebSite.f02a1c74.JPG";